import {
  MediaData,
  ClozeResponseNodeData,
  ClozeResponseData,
  ClozeMediaData,
} from '../../../types/quiz';
import {
  parseStringWithNode,
  parseStringWithOptions,
  formStringWithSelects,
} from './utils';

/**
 * ClozeData.
 */
export const mapClozeData = ({
  data,
  mediaData,
}: {
  data: ClozeResponseNodeData;
  mediaData: MediaData<ClozeMediaData[]>;
}): ClozeResponseData => {
  return {
    question: formStringWithSelects(parseStringWithOptions(data.q, mediaData)),
    mainExplanation: parseStringWithNode(data.e || '', mediaData),
    answers: parseStringWithOptions(data.q, mediaData),
  };
};
